import { Button, Navbar, Modal } from "react-bootstrap";
import { useRef } from "react";
import { useState, useContext, useEffect } from "react";
import { CartContext } from "../CartContext";
import CartProduct from "./CartProduct";
import { loadStripe } from "@stripe/stripe-js";
import "../cartProduct.css";
import { BsCart4 } from "react-icons/bs";
import { FaUserAlt } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import ShippingForm from "./ShippingForm";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios"; // For getting user info with token
import { collection, getDocs, query, where } from "firebase/firestore";
import { userDb } from "../firebaseUsers";
import { signInWithEmailAndPassword } from "firebase/auth";
import { userAuth } from "../firebaseUsers"; // Adjust path as needed

function Nav(props) {
  const cart = useContext(CartContext);
  const { email } = useContext(CartContext);
  const { updateItemRating } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showCart, setShowCart] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [showLoggedIn, setShowLoggedIn] = useState(false);
  const [custEmail, setEmail] = useState(null);
  const navigate = useNavigate();
  let src;
  const [loginCompleteResolver, setLoginCompleteResolver] = useState(null);
  const [user, setUser] = useState(null);
  const [rating, setRating] = useState(0);
  const [name, setName] = useState("");
  const { setorderNumber, setconfirmationNumber } = useContext(CartContext);
  const loginMenuRef = useRef(null);
  const [username, setUsername] = useState("");
  const [winner, setWinner] = useState(false);
  const [winnerEmail, setWinnerEmail] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWinner = async () => {
      const now = new Date();
      const previousMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
      const yearOfPreviousMonth =
        now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();

      try {
        const winnersRef = collection(userDb, "winners");
        const winnerQuery = query(
          winnersRef,
          where("month", "==", previousMonth),
          where("year", "==", yearOfPreviousMonth)
        );
        const winnerSnapshot = await getDocs(winnerQuery);

        if (!winnerSnapshot.empty) {
          const data = winnerSnapshot.docs[0].data();
          setWinner(data.winner);
          setWinnerEmail(data.email || null); // <-- ADDED: get winner email
          // console.log('Winner email:', data.email);
        } else {
          setWinner(null); // no winner yet
          setWinnerEmail(null);
        }
      } catch (error) {
        console.error("Error fetching winner:", error);
        setWinner(null);
        setWinnerEmail(null);
      }
    };

    fetchWinner();
  }, []);

  // CHECK if logged in user's email matches winner email
  const isWinnerUser = user?.email && winnerEmail && user.email === winnerEmail;
  // console.log(isWinnerUser,user,winnerEmail)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        loginMenuRef.current &&
        !loginMenuRef.current.contains(event.target) &&
        event.target.closest(".FaUserAlt") === null // if it's not the icon
      ) {
        setShowLoggedIn(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail");
    if (storedEmail) {
      setEmail(storedEmail);
      setLoggedIn(true);
      setUser(true);
    }
  }, []);
  const handleSearchClose = () => {
    setShowSearchBox(false);
  };

  const handleShowCart = () => {
    setShowCart(true);
  };

  const handleCloseCart = () => {
    setShowCart(false);
  };

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };
  const handleRatingChange2 = (id, newRating) => {
    updateItemRating(id, newRating);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      setShowSearchBox(false);
      // console.log("Search query:", searchQuery);
    }
  };
  const handleSearchIconClick = () => {
    setShowSearchBox(!showSearchBox);
  };
  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0
  );
  if (cart.items.length === 0 || productsCount === 0) {
    src = "";
  }
  if (cart.items.length === 1 || productsCount === 1) {
    src = "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925267/my_uploads/gmrrhhcltve2qdx0r8aj.png";
  }
  if (cart.items.length === 2 || productsCount === 2) {
    src = "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925262/my_uploads/gda0uohynqiiusp2cq4t.png";
  }
  if (cart.items.length > 2 || productsCount > 2) {
    src = "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925263/my_uploads/cl0rpx5gzss5x1h4qeqk.png";
  }

  const login = () => {
    return new Promise((resolve, reject) => {
      setLoginCompleteResolver(() => resolve); // Save resolve to call later
      try {
        loginGoogle(); // call the actual login function from useGoogleLogin
      } catch (error) {
        reject(error);
      }
    });
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        const userInfo = res.data;
        setLoggedIn(true);
        setUser(true);
        setName(userInfo.name);
        setEmail(userInfo.email);
        setShowLoggedIn(false);

        localStorage.setItem("userEmail", userInfo.email);
        window.dispatchEvent(new Event("userLogin"));
        if (loginCompleteResolver) {
          loginCompleteResolver(); // resolve the Promise to inform login is done
          setLoginCompleteResolver(null);
        }
      } catch (err) {
        console.error("Failed to fetch user info", err);
      }
    },
    onError: () => {
      alert("Login failed!");
    },
  });
  const handleLogout = () => {
    googleLogout(); // Ends session
    setLoggedIn(false);
    setUser(false);
    setName("");
    setEmail(null);
    localStorage.removeItem("userEmail");
    navigate("/");
  };

  const sanitizeInput = (input) => {
    return input.replace(/[^\w.@-]/gi, "").trim(); // Allows alphanumeric, underscore, dot, @, hyphen
  };

  const addCollection = () => {
    handleMenuItemClick();
    navigate("/admin-add-collection-firebase");
  };
  
  const addTheme = () => {
    handleMenuItemClick();
    navigate("/theme");
  };
    const gotoReview = () => {
    handleMenuItemClick();
    navigate("/stars");
  };
      const gotoProduct = () => {
    handleMenuItemClick();
    navigate("/product-manager");
  };
  const sendEmail = () => {
    handleMenuItemClick();
    navigate("/admin-upload-file");
  };

  const handleSignIn = async () => {
    // Sanitize input
    const cleanUsername = username.trim().replace(/[^\w.@-]/g, "");
    const cleanPassword = password.trim();

    // Basic validation
    if (!cleanUsername || !cleanPassword) {
      setError("");
      return;
    }

    try {
      // Look up email by sanitized username
      const usersRef = collection(userDb, "users");
      const q = query(usersRef, where("username", "==", cleanUsername));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError("Username not found.");
        return;
      }

      const userDoc = querySnapshot.docs[0];
      const email = userDoc.data().email;

      // Sign in with found email and sanitized password
      const userCredential = await signInWithEmailAndPassword(
        userAuth,
        email,
        cleanPassword
      );

      // Store info
      localStorage.setItem("userEmail", userCredential.user.email);
      window.dispatchEvent(new Event("userLogin"));
      setEmail(userCredential.user.email);
      setLoggedIn(true);
      setUser(true);

      alert(`Welcome back, ${cleanUsername}!`);

      // ✅ Hide form only if login is successful
      setShowLoggedIn(false);
    } catch (error) {
      console.error("Login error:", error);

      if (error.code === "auth/wrong-password") {
        setError("Incorrect password.");
      } else {
        setError("Login failed. Please try again.");
      }
    }
  };


  const checkout = async (addressTo, selectedShippingRate) => {
    try {
      let myArr = cart.items.map((item) => {
        // If uploadedImageUrl and image are the same, nullify uploadedImageUrl
        const uploadedImageUrl =
          item.uploadedImageUrl === item.image ? null : item.uploadedImageUrl;

        return [

          item.id,
          item.color,
          item.price,
          item.quantity,
          item.size,
          item.style,
          item.thumId,
          item.rating,
          item.weight,
          item.garmentPrice,
          item.imagePrice,
          item.thumImage,
          item.salePrice,
          uploadedImageUrl, // ✅ safe value
          item.image,
          item.imageSize3,
          item.imageSize4,
          item.colorName4API,
          item.thumFile


        ];
      });


      myArr.forEach((item, index) => {
        const str = JSON.stringify(item);
        // console.log(`Item ${index} has ${str.length} characters`);
      });

      const emailData = {
        from_name: "Online Store",
        to_name: "Payam",
        message: myArr,
      };
      const simplifiedItems = cart.items.map((item) => {
  const basePrice = parseFloat(item.price) || 0;
  const quantity = item.quantity;

  // Apply the same tiered discount
  let discount = 0;
  if (quantity >= 24 && quantity <= 47) {
    discount = 0.10;
  } else if (quantity >= 48 && quantity <= 99) {
    discount = 0.15;
  } else if (quantity >= 100) {
    discount = 0.20;
  }

  const discountedPrice = (basePrice * (1 - discount)).toFixed(2);

  return {
    id: item.id,
    style: item.style,
    color: item.color,
    size: item.size,
    thumId: item.thumId,
    image: item.image,
    quantity: quantity,
    price: parseFloat(discountedPrice),   // ✅ send discounted price per unit
    basePrice: basePrice,                 // (optional) keep original price for record
    discountPercent: discount * 100       // (optional) show discount info in backend
  };
});


      // ✅ Only take amount and provider
      const { amount, provider } = selectedShippingRate;

      const payload = {
        items: simplifiedItems,
        myArr,
        addressTo,
        shippingRate: { amount, provider }, // only these two
        custEmail,
        Status: "Received",
      };
      //  console.log("s:",simplifiedItems,"a:",myArr,selectedShippingRate,custEmail)
      const payloadString = JSON.stringify(payload);
      const sizeInBytes = new Blob([payloadString]).size;
      const sizeInKB = (sizeInBytes / 1024).toFixed(2);
      const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);

      const response = await fetch(
        "https://api-shipping-28612190fdf4.herokuapp.com/strp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to create checkout session");
      }

      const session = await response.json();
      const stripe = await loadStripe(process.env.REACT_APP_MAIN_KEY);

      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        console.error("Stripe Checkout error:", result.error);
      }
    } catch (error) {
      console.error("Checkout process failed:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchSubmit = () => {
    console.log("Searching for:", searchQuery);
    handleSearchClose();
  };
  const goToCSV = () => {
    navigate("/admin-csv-download", { state: { custEmail } });
  };
  const goToStore = () => {
    navigate("/admin-stores", { state: { custEmail } });
  };
 
  const gotoOrders = () => {
    navigate("/orders", { state: { custEmail } });
  };
    const gotoMock = () => {
    navigate("/mock", { state: { custEmail } });
  };
  const gotoSale = () => {
    navigate("/admin-sales-updater", { state: { custEmail } });
  };
  const gotoTags = () => {
    navigate("/admin-tags-updater", { state: { custEmail } });
  };
  const gotoOrders2 = () => {
    navigate("/admin-orders", { state: { custEmail } });
  };
  const handleMenuItemClick = () => {
    setShowLoggedIn(false);
  };
  const gotogame = () => {
    navigate("/game", { state: { custEmail } });
  };
  const gotoUsers = () => {
    navigate("/admin-all-users", { state: { custEmail } });
  };
  const gotoItems = () => {
    navigate("/admin-all-items", { state: { custEmail } });
  };
  const gotoField = () => {
    navigate("/admin-field-updater", { state: { custEmail } });
  };
  // console.log(loggedIn , custEmail)
  return (
    <>
      <Navbar expand="sm" className="d-flex justify-content-between">
        <Navbar.Brand href="/">
          <img
            id="logo"
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925386/my_uploads/hxauczbx0yznuhyoumbz.png"
            alt="logo"
            style={{ maxWidth: 70 }}
          />
        </Navbar.Brand>
        <div className="d-flex align-items-center">
          <a href="/" style={{ color: "black" }}>
            <IoHome
              className="mx-2"
              size={23}
              style={{ cursor: "pointer", marginTop: 6 }}
              title="About Us"
              onClick={() => { }}
            />
          </a>
          <FaUserAlt

            onClick={() => setShowLoggedIn((prev) => !prev)}
            // title='Login'
            style={{
              cursor: "pointer",
              fontSize: "18px",
              marginLeft: "8px",
              marginTop: "8px",
              color: user ? "#00FFB3" : "black", // 👈 Change color if logged in
            }}
          />
          <Button
            style={{ color: "black", backgroundColor: "white", border: "none" }}
            onClick={handleShowCart}
          >
            <BsCart4 size={20} style={{ cursor: "pointer" }} title="Cart" />
            <span className="cart-item-qty">
              {productsCount > 0 ? productsCount : ""}
            </span>
          </Button>
        </div>
      </Navbar>
      {showLoggedIn && (
        <div ref={loginMenuRef} style={{ marginBottom: 20, marginTop: -30 }}>
          <div
            style={{
              position: "absolute",
              top: 50,
              right: 10,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 15,
              zIndex: 1000,
              width: 225,
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          >
            {!loggedIn ? (
              <div style={{ zIndex: 9999, }}>
                {/* Username and Password Inputs */}
                <input
                  type="text"
                  placeholder="Username"
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Password"
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                  onClick={() => {
                    /* Add login handler here */
                    handleSignIn();
                    // handleMenuItemClick();
                  }}
                  style={{
                    backgroundColor: "#071d49",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                    fontSize: "13px",
                    padding: "6px 12px",
                  }}
                >
                  Login
                </Button>
                {error && <p style={{ color: "red" }}>{error}</p>}
                {/* Google Sign In */}
                <Button
                  onClick={() => {
                    login();
                    handleMenuItemClick();
                  }}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #071d49, #A60065)",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                    fontSize: "13px",
                    padding: "6px 12px",
                  }}
                >
                  Sign in with Google
                </Button>

                {/* Sign Up link */}
                <p style={{ textAlign: "center", margin: "10px 0 0" }}>
                  <a
                    href="/signup"
                    style={{
                      textDecoration: "none",
                      fontSize: "13px",
                      color: "#071d49",
                    }}
                  >
                    Don’t have an account? Sign up
                  </a>
                </p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: 10, }}>Welcome, {name}</p>

                <Button
                  onClick={() => {
                    gotoOrders();
                    handleMenuItemClick();
                  }}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #071d49, #A60065)",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                  }}
                >
                  Order History
                </Button>
                {/* <Button
                  onClick={() => {
                    gotogame();
                    handleMenuItemClick();
                  }}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #071d49, #A60065)",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                  }}
                >
                  Wear & Win
                </Button> */}

                {/* Admin Button */}
                {loggedIn && custEmail === process.env.REACT_APP_ADMIN_KEY && (
                  <>
                      <Button
                  onClick={() => {
                    gotoMock();
                    handleMenuItemClick();
                  }}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #071d49, #A60065)",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                  }}
                >
                  Mockup
                </Button>
                    <Button
                      onClick={() => {
                        gotoOrders2();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      All Orders
                    </Button>
                    <Button
                      onClick={() => {
                        gotoUsers();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      All accounts
                    </Button>
                    <Button
                      onClick={() => {
                        gotoItems();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Item lookup
                    </Button>
                    <Button
                      onClick={() => {
                        gotoSale();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Define Sale
                    </Button>
                    <Button
                      onClick={() => {
                        gotoTags();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Update Tags
                    </Button>
                    <Button
                      onClick={() => {
                        gotoField();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Update any Field
                    </Button>
                    <Button
                      onClick={() => {
                        goToCSV();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Download csv
                    </Button>
                                        <Button
                      onClick={() => {
                        sendEmail();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                      Generate img URL
                    </Button>
                    <Button
                      onClick={() => {
                        addCollection();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                     Add to collections
                    </Button>
                                        <Button
                      onClick={() => {
                        addTheme();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                     Change theme
                    </Button>
                                                            <Button
                      onClick={() => {
                        gotoProduct();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                     Product Manager
                    </Button>
                                        <Button
                      onClick={() => {
                        gotoReview();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                     Customers Review
                    </Button>
                                                            <Button
                      onClick={() => {
                        goToStore();
                        handleMenuItemClick();
                      }}
                      style={{
                        backgroundImage:
                          "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 10,
                        fontWeight: "bold",
                        height: 40,
                        border: "none",
                        width: "100%",
                        marginBottom: 10,
                      }}
                    >
                     Customers Stores
                    </Button>
                  </>
                )}

                <Button
                  onClick={() => {
                    handleLogout();
                    handleMenuItemClick();
                  }}
                  style={{
                    backgroundColor: "#d9534f",
                    border: "none",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    width: "100%",
                    marginBottom: 10,
                  }}
                >
                  Logout
                </Button>
              </>
            )}
          </div>
        </div>
      )}

      <Modal show={showSearchBox} onHide={handleSearchClose} centered>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyPress}
          />
          <Button
            variant="primary"
            style={{ width: "100%", marginTop: "10px" }}
            onClick={handleSearchSubmit}
          >
            Enter
          </Button>
        </Modal.Body>
      </Modal>

      {/* Cart Modal */}
      <Modal
        show={showCart}
        onHide={handleCloseCart}
        fullscreen={false}
        style={{ zIndex: 1050 , marginLeft:-6}}
      >
        <Modal.Header closeButton>
          <Modal.Title>
<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  {src && <img src={src} style={{ maxWidth: 50 }} alt="cart" />}
  <span>Shopping Cart</span>
</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Content for Cart */}
          {productsCount > 0 ? (
            <>
              {cart.items.map((currentProduct, idx) => (
                <CartProduct
                  key={idx}
                  id={currentProduct.id}
                  quantity={currentProduct.quantity}
                  image={currentProduct.image}
                  src={src}
                  rating={currentProduct.rating}
                  onRatingChange={handleRatingChange2}
                ></CartProduct>
              ))}
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h1>
                  Subtotal: <sup style={{ fontSize: 20 }}>$ </sup>
                  {cart.getTotalCost().toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </h1>

              </div>
                            <div>
<p style={{ color: "green" }}>You saved: ${cart.getTotalSavings().toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
</div>
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <ShippingForm
                  onCheckout={checkout}
                  showLoginModal={() => setShowLoggedIn(true)}
                  user={user}
                  custEmail={custEmail}
                  name={name}
                  total= {cart.getTotalCost().toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  loggedIn={loggedIn}
                  showLoggedIn={showLoggedIn}
                  login={login}
                  error={error}
                  handleMenuItemClick={handleMenuItemClick}
                  handleSignIn={handleSignIn}
                />
              </div>
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="mt-3" style={{ textAlign: "right" }}>
                  <a href="/" style={{ textDecoration: "none" }}>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                      <li>
                        <img
                          src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925267/my_uploads/gk6ekj4uzuuxvtus0bbi.png"
                          style={{ maxWidth: 28, marginRight: 5 }}
                        ></img>
                        Keep Shopping
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </>
          ) : (
            <div
              id="p"
              style={{
                alignItems: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f622/512.gif"
                style={{ maxWidth: 50 }}
              ></img>
              <h1>There are no items in your cart!</h1>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Nav;
